import React, { useState } from "react";
import ContactUsModal from "../ContactUsModal/contactUsModal";

/**
 * Same real ContactUsModal (open/setOpen state) the old ContactUs.tsx used -- only the
 * surrounding visual card changed, no submission logic touched.
 */
const FAQContactCTA: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="fq-contact">
      <div className="fq-contact__card">
        <div className="fq-contact__glow fq-contact__glow--1" />
        <div className="fq-contact__glow fq-contact__glow--2" />
        <div className="fq-contact__content">
          <h3 className="fq-contact__heading">Still have a question?</h3>
          <p className="fq-contact__lede">
            We&apos;d love to hear from you. Drop us a note and we&apos;ll get back within one
            business day.
          </p>
          <button type="button" className="fq-contact__btn" onClick={() => setOpen(true)}>
            Contact us
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <ContactUsModal open={open} setOpen={setOpen} />
    </section>
  );
};

export default FAQContactCTA;
